export default __webpack_public_path__ + "static/media/side-dishes.dd65f1eb.jpg";